import { Field, TextField as DSTextField, type FieldClassNames } from "@eisox/design-system";

import { useFieldContext } from "../form.context";
import { FieldErrors } from "./field-errors.component";

interface TextFieldProps extends Omit<React.ComponentProps<typeof DSTextField.Root>, "className"> {
  label?: string;
  description?: string;
  classNames?: FieldClassNames;
}

const TextField: React.FC<TextFieldProps> = ({
  label,
  description,
  classNames,
  children,
  onChange,
  onBlur,
  ...props
}) => {
  const field = useFieldContext<string | number | undefined>();

  return (
    <Field.Root className={classNames?.root}>
      <Field.Label className={classNames?.label}>{label}</Field.Label>
      <Field.Description className={classNames?.description}>{description}</Field.Description>
      <Field.Control
        render={
          <DSTextField.Root
            {...props}
            className={classNames?.control}
            value={field.state.value ?? ""}
            onChange={event => {
              field.handleChange(event.target.value);
              onChange?.(event);
            }}
            onBlur={event => {
              field.handleBlur();
              onBlur?.(event);
            }}
          >
            {children}
          </DSTextField.Root>
        }
      />
      <FieldErrors className={classNames?.error} />
    </Field.Root>
  );
};

export { TextField };
export type { TextFieldProps };
